module.exports = __webpack_public_path__ + "img/headbg-0.6db8005b.png";